import { createStore } from "vuex";
import { auth } from "./auth.module";
import { storecards } from "./storecards.module";
import receivedOrdersService from "@/services/receivedorders.service";

const store = createStore({
  modules: {
    auth,
    storecards
  },
  state: {
    basket: {
      items: [],
      firm: {},
      paidAmount: 0,
      paymentType: null,
      printBill: false
    },
    receivedOrder: null,
    issuedOrder: null
  },
  mutations: {
    addToBasket(state, item) {
      console.log('Adding to basket:', item);
      item.BasketQuantity = 1;
      item.PosIndex = state.basket.items.length + 1;
      state.basket.items.push(item);
    },
    removeFromBasket(state, index) {
      console.log('Removing from basket:', index);
      state.basket.items.splice(index, 1);
    },
    setBasketFirm(state, firm) {
      state.basket.firm = firm;
      console.log('Basket firm set to:', firm);
    },
    processBasketAsReceived(state) {
      console.log('Processing basket as received order:', state.basket);
      let i = 1;
      state.receivedOrder = receivedOrdersService.newReceivedOrder();
      state.receivedOrder.Rows = [...state.basket.items].map(row => ({
        PosIndex: i++,
        StoreCard_ID: row.ID,
        RowType: 3,
        Division_ID: "1000000101",
        Store_ID: row.Store_ID,
        X_CoverNumber: row.X_CoverNumber.split(':')[1],
        Quantity: row.BasketQuantity,
        QUnit: "ks",
        UnitPrice: row.X_Price,
        TAmount: row.BasketQuantity * row.X_Price
      }));
      state.receivedOrder.Firm_ID = state.basket.firm.ID;
      state.receivedOrder.PMState_ID = "2010000101";
      state.receivedOrder.PaymentType_ID = state.basket.paymentType.ID;
      state.receivedOrder.X_PaidAmount = state.basket.paidAmount;
      state.receivedOrder.Confirmed = true;
      console.log('Received order:', state.receivedOrder);
      receivedOrdersService.create(state.receivedOrder)
        .then((response) => {
          console.log(response.data);
          state.receivedOrder = response.data;
          console.log('Received order created:', state.receivedOrder);
          let params = {};
          params["ID"] = state.receivedOrder.id;
          params["queryFilter"] = true;
          receivedOrdersService.getAll(params).then((response) => {
            console.log('Received order fetched:', response.data);
            state.receivedOrder = response.data;
          });
        })
        .catch((e) => {
          console.log(e);
        });
      state.basket.items = []; // clear the basket after processing
      state.basket.firm = {}; // clear the firm after processing
    },
    processBasketAsIssued(state) {
      console.log('Processing basket as issued order:', state.basket);
      // Example items creation
      let i = 1;
      state.issuedOrder.Rows = [...state.basket.items].map(row => ({
        PosIndex: i++,
        StoreCard_ID: {
          ID: row.ID,
          Code: row.Code,
          DisplayName: row.DisplayName
        },
        X_CoverNumbers: row.X_CoverNumbers,
        Quantity: row.BasketQuantity,
        QUnit: "ks",
        UnitPrice: row.X_Price,
        TAmount: row.BasketQuantity * row.X_Price
      }));
      state.issuedOrder.Firm_ID = state.basket.firm.id;
      console.log('Issued order:', state.issuedOrder);  
      state.basket.items = []; // clear basket
      state.basket.firm = {}; // clear firm
    }
  },
  getters: {
    basketItemCount: state => state.basket.items.length,
    basketItems: state => state.basket.items,
    basketFirm: state => state.basket.firm,
    paidAmount: state => state.basket.paidAmount,
    paimentType: state => state.basket.paimentType
  }
});

export default store;